import { Fragment } from "react"
import classNames from "classnames"
import "./HeatmapRowHours.scss"
import { Timer } from "~/types"
import { HeatmapHour } from "~/hooks/heatmap"

const VISIBLE_HOURS: number[] = []
for (let h = 0; h < 24; h++) VISIBLE_HOURS.push(h)

interface HeatmapRowHoursProps {
  heatmapHours: HeatmapHour[]
  date?: string
  runningTimer?: Timer | null
}

const formatNumber = (num: number) => Math.round(num * 10) / 10

const cellTitle = (hourData?: HeatmapHour) => {
  if (!hourData || hourData.work + hourData.back_to_back === 0) return undefined

  const parts = [`${formatNumber(hourData.work)} work`]
  if (hourData.back_to_back > 0) {
    parts.push(
      `${formatNumber(hourData.back_to_back)} back-to-back (not counted)`,
    )
  }
  parts.push(`${formatNumber(hourData.break)} break`)
  return parts.join(", ")
}

function HeatmapRowHours({
  heatmapHours,
  date,
  runningTimer,
}: HeatmapRowHoursProps) {
  let startedHour: number | null = null
  let startedDate: string | null = null

  if (runningTimer) {
    const startedAt = new Date(runningTimer.started_at)
    startedHour = startedAt.getHours()
    startedDate = startedAt.toLocaleDateString("sv")
  }

  return (
    <>
      {VISIBLE_HOURS.map((hour) => {
        const hourData = heatmapHours.find((h) => h.hour === hour)
        const isCurrentCell = hour === startedHour && date === startedDate
        const total = hourData?.work ?? 0
        const backToBack = hourData?.back_to_back ?? 0
        const isFilled = total > 0 || isCurrentCell
        return (
          <Fragment key={hour}>
            {(hour === 7 || hour === 17) && (
              <div className="HeatmapRowHours__spacer" />
            )}
            <div className="HeatmapRowHours__cell" title={cellTitle(hourData)}>
              <div
                className={classNames("HeatmapRowHours__dot", {
                  "HeatmapRowHours__dot--filled": isFilled,
                  "HeatmapRowHours__dot--back-to-back": backToBack > 0,
                  "HeatmapRowHours__dot--pulsing": isCurrentCell,
                })}
                style={
                  {
                    "--count": total,
                    "--total-count": total + backToBack,
                  } as React.CSSProperties
                }
              />
            </div>
          </Fragment>
        )
      })}
    </>
  )
}

export default HeatmapRowHours
